import { c as _c } from "react/compiler-runtime";
import { getErrorCode } from '@onefootprint/fetch-hosted';
import { useRequestError } from '@onefootprint/fetch-hosted/use-request-error';

/**
 * Returns a function that extracts a user-facing error message from a vault mutation error.
 * For T120 (validation) errors, pulls the field-specific message from the error context.
 * Falls back to the generic error message otherwise.
 */
export const useVaultErrorMessage = () => {
  const $ = _c(3);
  const {
    getErrorContext,
    getErrorMessage
  } = useRequestError();
  let t0;
  if ($[0] !== getErrorContext || $[1] !== getErrorMessage) {
    t0 = (error, field) => {
      const code = getErrorCode(error);
      const ctx = code === "T120" ? getErrorContext(error) : {};
      const message = ctx[field] as string ?? getErrorMessage(error);
      return typeof message === "string" ? message : undefined;
    };
    $[0] = getErrorContext;
    $[1] = getErrorMessage;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};